<template>
  <div v-if="liveTrack">
    <h2 class="o-playlist__heading">Nu op Qmusic</h2>

    <ul class="c-playlist c-playlist--large c-playlist--dividers">
      <li class="c-playlist__item">
        <div class="o-playlist">
          <div class="o-playlist__position">
            {{ liveTrack.position }}
          </div>

          <div class="o-playlist__image">
            <img v-if="thumbnailUrl" :src="thumbnailUrl" :alt="liveTrack.title">
          </div>
          <div class="o-playlist__content">
            <h3 class="o-playlist__title">{{liveTrack.title}}</h3>
            <p class="o-playlist__artist">{{liveTrack.artist.name}}</p>
          </div>
          <div class="o-playlist__actions">
            <!-- <a href="#" class="c-button c-button--large">bekijk in de lijst</a> -->
          </div>
        </div>
      </li>

    </ul>
  </div>
</template>

<script>
import { cdnUrl } from '../../filters/imageFilters'
import { mapGetters } from 'vuex';
  export default {
  name: 'Now',
  computed: {
    ...mapGetters('hitlist', [
      'liveTrack'
    ]),
    thumbnailUrl() {
      return cdnUrl(this.liveTrack.thumbnail, 'cover/w300')
    }
  },
  data() {
    return {
    }
  }
};
</script>
